import i18n from "i18next";

export const BannerElements = {
  BUTTON: "button",
  ICONLOGO: "iconLogo",
  TEXT: "text",
  TITLE: "title",
};
export const DefaultActiveElements = [
  BannerElements.BUTTON,
  BannerElements.ICONLOGO,
  BannerElements.TEXT,
  BannerElements.TITLE,
];

export const ITEM_STATUS = {
  NONE: "none",
  NEW: "new",
  PENDING: "pending review",
  ORDERED: "ordered",
  SHIPPED: "shipped",
  DECLINED: "declined",
  COMPLETED: "completed",
  PREORDER: "pre-order",
};

export const ITEM_STATUS_TO_LOZENGE_APPEARANCE_MAP = {
  none: "none",
  new: "new",
  "pending review": "new",
  ordered: "inprogress",
  shipped: "moved",
  "pre-order": "moved",
  declined: "removed",
  completed: "success",
};

export const translateStatus = (status) => i18n.t(status);

export const ALLOWED_STATUS_TRANSITIONS = {
  [ITEM_STATUS.NONE]: [ITEM_STATUS.ORDERED, ITEM_STATUS.DECLINED],
  [ITEM_STATUS.NEW]: [ITEM_STATUS.ORDERED, ITEM_STATUS.DECLINED],
  [ITEM_STATUS.PENDING]: [ITEM_STATUS.ORDERED, ITEM_STATUS.DECLINED],
  [ITEM_STATUS.ORDERED]: [ITEM_STATUS.SHIPPED, ITEM_STATUS.COMPLETED],
  [ITEM_STATUS.SHIPPED]: [ITEM_STATUS.COMPLETED],
  [ITEM_STATUS.DECLINED]: [ITEM_STATUS.NONE],
  [ITEM_STATUS.COMPLETED]: [],
  [ITEM_STATUS.PREORDER]: Object.values(ITEM_STATUS).filter(
    (someStatus) => someStatus !== ITEM_STATUS.PREORDER
  ),
};

export const ORDER_STATUS = {
  IN_PROGRESS: "inprogress",
  APPROVED: "approved",
  COMPLETED: "completed",
  DECLINED: "declined",
};

// some attribute types have weird info in the ... like, integer, float, select, etc. will have defaultType property and within it a name (that say "Integer", "Float", etc
// but User type doesn't, it has a "type" property, which is a value as shown before
// i guess it has something to do with the default types being separate from the others
// CBA to look into it
export const ATTRIBUTE_TYPE = {
  USER: 2,
  OBJECT: 1,
  PROJECT: 6,
  STATUS: 7,
};

export const ALLOWED_ATTRIBUTE_TYPES = [
  "Select",
  "Text",
  "Integer",
  "Float",
  "Textarea",
  "IP Address",
  "Date",
  "DateTime",
  ATTRIBUTE_TYPE.USER,
];

export const FILTERABLE_ATTRIBUTE_TYPES = [
  "Text",
  "Integer",
  "Float",
  "Select",
  ATTRIBUTE_TYPE.OBJECT,
  ATTRIBUTE_TYPE.PROJECT,
  ATTRIBUTE_TYPE.STATUS,
];

export const MODAL_IDS = {
  EDIT_ORDER_MODAL: "edit-order-modal",
  ORDER_RECEIVED_MODAL: "order-received-modal",
  APPROVE_ORDER_MODAL: "approve-order-modal",
  ADD_TO_ASSETS_MODAL: "add-to-assets-modal",
  PUBLISH_CATALOG_MODAL: "publish-catalog-modal",
};

export const VIEW_MODE = {
  SHOP: "shop",
  ADMIN: "admin",
};

export const Breakpoint = {
  mobile: `(max-width: 480px)`,
};
